export default "__VITE_ASSET__DULSYsr___"